import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { menuBackoffice } from '../../constant/Constant'
import { RootStateType } from '../../redux/reducer/rootReducer'
import { clearProfileData } from '../../redux/action/profile'
import { getBackofficeMenuByPermission } from '../../util/utilityFunction'

const useBackoffice = () => {
    const { permissions } = useSelector(({ profile }: RootStateType) => profile)
    const dispatch = useDispatch()
    const history = useHistory()

    const [menuList, setMenuList] = useState<BackofficeMenuType[]>(menuBackoffice)

    useEffect(() => {
        const permissionMenu = getBackofficeMenuByPermission(permissions)
        setMenuList(permissionMenu)
    }, [permissions])

    const onClickLogout = () => {
        globalThis.localStorage.removeItem(`${process.env.REACT_APP_ACCESS_TOKEN_NBTC}`)
        globalThis.localStorage.removeItem(`${process.env.REACT_APP_ACCESS_TOKEN_USER}`)
        globalThis.localStorage.removeItem(`${process.env.REACT_APP_IS_LOGIN}`)
        globalThis.sessionStorage.clear()
        globalThis.localStorage.removeItem(`${process.env.REACT_APP_TOKEN_PROFILE}`)
        dispatch(clearProfileData())
        history.push('')
    }

    return {
        menuList,
        onClickLogout,
    }
}

export default useBackoffice
